const PERMISSION_KEY= "core:tenant_auth_policy";
const PAGE_URL = {
    TENANT_AUTH_POLICY_PAGE: "/admin/core/tenant-auth-policy"
}

export {PERMISSION_KEY, PAGE_URL}

